/* eslint-disable */
// import AuthService from "@/services/AuthService";
import ReportsService from "@/services/ReportsService";
import { forEach } from "lodash";
import { defineStore } from "pinia";
import { toast } from "vue3-toastify";

export const useReportStore = defineStore("ReportStore", {

  state: () => ({


    acknowledgements: [],

    talksCreatedCount: null,
    acknowledgementsCompletedCount: null,
    acknowledgementsNotCompletedCount: null,
    subManagers: null,
    allCampaignsInAckTableForThisManager: [],

    currentUser: {},

    allManagers: [],

    showSearchOptionsModal: false,

    searchFormData: {
      manager_id: null,
      // campaign_id: null,
      start_date: null,
      end_date: null,
      completion_type: null,

      teams: [], //array of teams to only pull data for
      tags: [],
    },

    isLoading: false,

    showExportButton: false,

    allTeams: [],

    showSelectTeamsModal: false,
    showSelectEmployeesOnATeamModal: false,

    currentTeam: {},

    showCreateNewTagModal: false,

    tagFormData: {
      id: null,
      name: null,
    },

    tags: [],

    showUpdateTagModal: false,
    showDeleteTagModal: false,
    currentTag: {},


    showSelectTagsModal: false,
    allTags: [],

    



  }),



  actions: {



    fetchAllAcknowledgments() {

      this.isLoading = true

      ReportsService.getAllTalksForACampaign()
        .then((response) => {

          this.showExportButton = false

          this.currentUser = response.data.currentUser
          this.talksCreatedCount = response.data.talksCreatedCount
          this.acknowledgementsCompletedCount = response.data.acknowledgementsCompletedCount
          this.acknowledgementsNotCompletedCount = response.data.acknowledgementsNotCompletedCount
          this.acknowledgements = response.data.acknowledgements
          this.allManagers = response.data.allManagers
          this.allCampaignsInAckTableForThisManager = response.data.allCampaignsInAckTableForThisManager
          this.allTeams = response.data.teams
          this.allTags = response.data.tags


          this.setSearchBoxState()


          this.isLoading = false

          // console.log(response.data)


        }).catch((err) => {

          this.isLoading = false

          console.log(err)

        });

    },

    setSearchBoxState() {

      this.searchFormData.manager_id = this.currentUser.id
      // this.searchFormData.campaign_id = 'all_campaigns'
      this.searchFormData.start_date = null
      this.searchFormData.end_date = null
      this.searchFormData.completion_type = 'all',
        this.searchFormData.teams = []


    },


    openSearchOptionsModal() {
      // this.populateManagersArray()
      this.showSearchOptionsModal = true
    },

    closeSearchOptionsModal() {
      this.showSearchOptionsModal = false
    },

    limitText(body) {
      if (body.length > 40) {
        return body.substring(0, 40) + "...";
      }

      return body;
    },


    searchACKData() {

      this.showExportButton = true
      this.isLoading = true

      // console.log('searchFormData', this.searchFormData)

      ReportsService.searchAcknowledgments(this.searchFormData)
        .then((response) => {

          setTimeout(() => {

            this.isLoading = false;

            this.talksCreatedCount = response.data.talksCreatedCount
            this.acknowledgementsCompletedCount = response.data.acknowledgementsCompletedCount
            this.acknowledgementsNotCompletedCount = response.data.acknowledgementsNotCompletedCount
            this.acknowledgements = response.data.acknowledgements

            this.closeSearchOptionsModal()


            // console.log('response', response.data)
            console.log('ack araay', this.acknowledgements)

          }, 1000);




        }).catch((err) => {

          console.log(err)

        });





    },


    exportSearchFormData() {

      ReportsService.exportAckDataFromSearch(this.searchFormData)
        .then((response) => {


          // Create a Blob from the PDF Stream
          const file = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
          })

          // Build a URL from the file
          const fileURL = URL.createObjectURL(file)

          // Open the URL on new Window
          const link = document.createElement('a')
          link.href = fileURL
          link.setAttribute('download', 'TalksData.xlsx')
          document.body.appendChild(link)
          link.click()

          // console.log(response.data)

        }).catch((err) => {

          console.log(err)

        });

    },



    openSelectTeamsModal() {
      this.showSelectTeamsModal = true
    },


    closeSelectTeamsModal() {
      this.showSelectTeamsModal = false
    },



    openSelectEmployeesOnATeamModal() {
      this.showSelectEmployeesOnATeamModal = true
    },





    setCurrentTeam(team) {
      this.currentTeam = team
      this.openSelectEmployeesOnATeamModal()
    },


    addThisTeamToSearchFormDataTeamList(team) {



      if (team.user_teams.length > 0) {


        let theTeam = team;

        // Find the index of the team in the array
        const teamIndex = this.searchFormData.teams.findIndex(
          (team) => team.id === theTeam.id
        );

        if (teamIndex !== -1) {

          // team exists, remove it from the array
          this.searchFormData.teams.splice(teamIndex, 1);
          team.is_checked = 0;

          // console.log("team removed from array");

        } else {

          // team does not exist, add it to the array
          this.searchFormData.teams.push(theTeam);
          team.is_checked = 1;

          // console.log("Add group to array as the user does not exist in it");
        }





      } else {


        alert('has 0 users. You cannot select a group that has no supervisors.')

      }



    },



    toggleEmployeeToAndFromTeamSearchList(user_team) {


      //find the team this user_team is on
      const team = this.searchFormData.teams.find(
        (team) => team.id === user_team.team_id
      );


      //check if the user_team is checked is 1 or 0
      const userTeamIndex = team.user_teams.findIndex(
        (userTeam) => userTeam.user_id === user_team.user_id
      );




      if (user_team.is_checked) {

        user_team.is_checked = 0

        // console.log('unchecked')

      } else {

        user_team.is_checked = 1

        // console.log('checked')

      }



    },


    selectAllTeamMembers() {
      this.currentTeam.user_teams.forEach((user_team) => {
        user_team.is_checked = 1
      });
    },

    unSelectAllTeamMembers() {
      this.currentTeam.user_teams.forEach((user_team) => {
        user_team.is_checked = 0
      });
    },


    checkIfAtleastOneTeamMemberWasSelected() {
      const hasAtLeastOne = this.currentTeam?.user_teams?.some(
        user_team => user_team.is_checked
      );

      return !hasAtLeastOne; // returns true if error (none selected)
    },

    closeSelectEmployeesOnATeamModal() {

      if (this.checkIfAtleastOneTeamMemberWasSelected()) {

        alert('At least 1 team member must be selected!')

        return

      }


      this.showSelectEmployeesOnATeamModal = false;

    },


    openCreateNewTagModal() {
      this.tagFormData.id = null
      this.tagFormData.name = null

      this.showCreateNewTagModal = true
    },

    closeCreateNewTagModal() {
      this.showCreateNewTagModal = false
    },


    createNewTag() {

      if (this.tagFormData.name === null) {
        alert('Please give the tag a name!')
        return;
      }


      const formData = {
        name: this.tagFormData.name
      }

      ReportsService.storeNewTagService(formData)
        .then((response) => {


          this.fetchAllTags()
          this.closeCreateNewTagModal()

          toast("Tag created!", {
            position: "bottom-right",
            autoClose: 2000,
          });

          // console.log(response.data)

        }).catch((err) => {

          console.log(err)

        });



    },

    fetchAllTags(){

      this.tags = [];

      ReportsService.getAllTagsService()
        .then((response) => {

          this.tags = response.data.tags
          
          // console.log(response.data)
          
        }).catch((err) => {

          console.log(err)
          
        });


    },


    setCurrentTag(tag){
      this.currentTag = tag
    },

    openUpdateTagModal(tag){
      this.setCurrentTag(tag)
      this.showUpdateTagModal = true
    },

    closeUpdateTagModal(){
      this.showUpdateTagModal = false
    },

    updateTag(){

      const formData = {
        tag: this.currentTag
      }


      ReportsService.updateTagService(formData)
        .then((response) => {


          this.closeUpdateTagModal()


          // console.log(response.data)
          
        }).catch((err) => {

          console.log(err)
          
        });


      console.log(formData)

    },


    openDeleteTagModal(tag){
      this.setCurrentTag(tag)
      this.showDeleteTagModal = true
    },

    closeDeleteTagModal(){
      this.showDeleteTagModal = false
    },


    deleteTag(){

      const formData = {
        tag: this.currentTag
      }

      ReportsService.deleteTagService(formData) 
        .then((response) => {


          this.fetchAllTags()
          this.closeDeleteTagModal()

          toast("Tag deleted!", {
            position: "bottom-right",
            autoClose: 2000,
          });



          // console.log(response.data)
          
        }).catch((err) => {

          console.log(err)
          
        });

    },


    opensSelectTagsModal(){
      this.showSelectTagsModal = true
    },

    closeSelectTagsModal(){
      this.showSelectTagsModal = false
    },


    addThisTagToSearchFormDataTagList(tag) {


        let theTag = tag;

        // Find the index of the tag in the array
        const tagIndex = this.searchFormData.tags.findIndex(
          (tag) => tag.id === theTag.id
        );

        if (tagIndex !== -1) {

          // tag exists, remove it from the array
          this.searchFormData.tags.splice(tagIndex, 1);
          tag.is_checked = 0;

          // console.log("tag removed from array");

        } else {

          // team does not exist, add it to the array
          this.searchFormData.tags.push(theTag);
          tag.is_checked = 1;

          // console.log("Add tag to array as the user does not exist in it");
        }





   


    },



    













  },


});
